function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Home Testimonials
 *    Scripts for the Testimonials Carousel section.
 *
 *  Version:
 *    1.0.0 - 2020/02/17 
 */

import { CarouselSection } from './../../sections/carousel/CarouselSection';
import { register } from './../../sections/ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

//Elements
export var CONTAINER_SELECTOR = '[data-home-testimonials]';
export var CAROUSEL_SELECTOR = '[data-home-tesimonials-carousel]';

//Attrs
export var TESTIMONIAL_CONTROL = 'data-testimonial-control';
export var SLICK_INDEX = 'data-slick-index';

//Classes
export var CLASS_ACTIVE = 'is-active';
export var HomeTestimonials = /*#__PURE__*/function (_CarouselSection) {
  _inherits(HomeTestimonials, _CarouselSection);
  var _super = _createSuper(HomeTestimonials);
  function HomeTestimonials(container) {
    var _this;
    _classCallCheck(this, HomeTestimonials);
    _this = _super.call(this, container);
    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.slick = _this.initCarousel(_this.carouselContainer);
    _this.carouselControl = container.find("[".concat(TESTIMONIAL_CONTROL, "]"));
    container.on('click', "[".concat(TESTIMONIAL_CONTROL, "]"), function (e) {
      return _this.onControlClick(e);
    });
    container.on('beforeChange', CAROUSEL_SELECTOR, function (e, slick, currentSlide, nextSlide) {
      _this.updateControls(slick, currentSlide, nextSlide);
    });
    return _this;
  }
  _createClass(HomeTestimonials, [{
    key: "onControlClick",
    value: function onControlClick(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      var id = self.attr(TESTIMONIAL_CONTROL);
      if (!id) return;
      this.carouselContainer.slick('slickGoTo', id);
    }
  }, {
    key: "optionOverrides",
    value: function optionOverrides() {
      var _ref;
      return _ref = {
        infinite: this.container.data('infinite') === true ? true : false,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: true
      }, _defineProperty(_ref, "arrows", false), _defineProperty(_ref, "adaptiveHeight", false), _defineProperty(_ref, "responsive", [{
        breakpoint: ResponsiveSizes.medium - 1,
        settings: {
          slidesToShow: 1,
          dots: false
        }
      }]), _ref;
    }
  }, {
    key: "updateControls",
    value: function updateControls(slick, currentSlide, nextSlide) {
      this.carouselControl.removeClass(CLASS_ACTIVE);
      var control = this.container.find("[".concat(TESTIMONIAL_CONTROL, "=\"").concat(nextSlide, "\"]"));
      control.addClass(CLASS_ACTIVE);
    }
  }]);
  return HomeTestimonials;
}(CarouselSection);
register(CONTAINER_SELECTOR, HomeTestimonials);